import { defineTranslateKeys } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import { translations as nicheTranslations } from '../common/niche.i18n'

export const translations = defineTranslateKeys({
  title: {
    defaultValue: 'Criar report',
    key: 'CreateNicheDashboardModal-title',
  },
  textLabel: TOLGEE_GLOBALS.reportName,
  description: {
    defaultValue: `Crie um report automático com os principais vídeos, creators e a descrição dos nichos do seu interesse. Escolha abaixo os nichos que deseja no seu report:`,
    key: 'CreateNicheDashboardModal-description',
  },
  nicheLimitMessage: nicheLimit => ({
    key: 'CreateNicheDashboardModal-nicheLimitMessage',
    parameters: {
      nicheLimit,
      strong: <strong />,
    },
    defaultValue: 'Para melhor visualização do report, é possível selecionar <strong>até {nicheLimit} nichos</strong>.',
  }),
  nicheMinLimitMessage: nicheTranslations.nicheMinLimitMessage,
})
